// CollapsibleMenu.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const MenuItem = ({ item }) => {
  const [isOpen, setIsOpen] = useState(item.initiallyOpen || false);
  const navigate = useNavigate();
  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  const hasChildren = item.children && item.children.length > 0;

  return (
    <div className="menu-item">
      <div 
        className="menu-item-header" 
        onClick={hasChildren ? toggleOpen : undefined}
        style={{ 
          padding: '10px 15px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          cursor: hasChildren ? 'pointer' : 'default',
          borderBottom: '1px solid #eee'
        }}
      >
        <span onClick={()=>navigate(`/category/${item.label}`)}>{item.label}</span>
        {hasChildren && (
          <span style={{ marginLeft: '5px' }}>
            {isOpen ? '▾' : '▸'}
          </span>
        )}
      </div>
      
      {hasChildren && isOpen && (
        <div className="menu-item-children" style={{ paddingLeft: '20px' }}>
          {item.children.map((child, index) => (
            <MenuItem key={index} item={child} />
          ))}
        </div>
      )}
    </div>
  );
};

const CollapsibleMenuComponent = ({ menuData, width = '300px', style = {} }) => {
  return (
    <div 
      className="collapsible-menu" 
      style={{ 
        width: width, 
        border: '1px solid #ddd',
        borderRadius: '4px',
        overflow: 'hidden',
        ...style
      }}
    >
      {menuData.map((item, index) => (
        <MenuItem key={index} item={item} />
      ))}
    </div>
  );
};

export default CollapsibleMenuComponent;